import { UPDATE_PASSWORD_ERROR, UPDATE_PASSWORD_SUCCESS, UPDATE_PASSWORD_POST_ERROR} from "../actions/types";

export default (state = { error: "", success: "", isSwitchSnackbarOn: false }, action) => {
    switch (action.type) {
        case UPDATE_PASSWORD_ERROR:
            return {
                ...state,
                error: UPDATE_PASSWORD_ERROR,
                success: state.success,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: action.payload,
                key: action.key,
            };
        case UPDATE_PASSWORD_SUCCESS:
            return {
                ...state,
                error: UPDATE_PASSWORD_SUCCESS,
                success: action.payload,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Update Password Successful',
                key: action.key,
            };
        case UPDATE_PASSWORD_POST_ERROR:
            return {
                ...state,
                error: UPDATE_PASSWORD_POST_ERROR,
                success: action.payload,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Update Password Failed. Please contact administrator',
                key: action.key,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/updatePasswordReducer.js